import { financeAPI } from "../../axios";

export const actions = {
    GetGLByAccount(context, data){
        return financeAPI.post(`GeneralLedger/Account/${data.campusId}/${data.fundClusterId}/${data.accountId}`, data);
    },
    GetGLByFundCluster(context, data){
        return financeAPI.post(`GeneralLedger/All/${data.campusId}/${data.fundClusterId}`, data);
    },

}